// Regiao de Estudo
// import Fuse from 'fuse.js'
import api from '@/api.js'



export default function(data) {

    var state = {
        user:false,
        loaded:false,
    }

    return {
        state: state,
        mutations: {          
            setMutation:function(state,data){
                //debugger;
                _.each(data,(v,k)=>{
                    state[k] = v;
                })
            },
        },

        actions: {

            register:async function(ctx,data){

                var response = await api.postJSONAsync('register',data)
                
                
                if(response.error){
                    return response;//await response.json();
                }
            
                //make login if all is ok
                saveToken(response.token);
                ctx.commit('setMutation',{user:response});
                return true;
            },

            updateUser:async function(ctx,data){
                
                data.id = ctx.getters.user.id;

                var response = await api.postJSONAsync('updateUser',data)

                if(response.error){
                    return response;//await response.json();
                }
                ctx.commit('setMutation',{user:response});
                return true;
            },

            login:async function(ctx, {cpf, password} ){
                    
                    var resources = {password:password};
                    resources.username = cpf;
                    var response = await api.postJSONAsync('login',resources)
                    //debugger;
                    if(response.error){
                        return response;//await response.json();
                    }
                    //salvo o token
                    saveToken(response);
                    ctx.dispatch('getUserFromToken')
                    return true;
            },

            recoverpassword:async function(ctx, {cpf} ){
                    
                var resources = {cpf};
                var response = await api.postJSONAsync('resetPasswordForCPF',resources)
                if(response.error){
                    return response;//await response.json();
                }
                //salvo o token
                return response;
            },


            setNewPassword:async function(ctx, {password,token} ){
                //debugger;
                var resources = {password:password};
                //log the user as token
                saveToken({id:token})
                await ctx.dispatch('getUserFromToken')

                var response = await api.postJSONAsync('setpassword',resources)
                if(response.error){
                    return response;//await response.json();
                }
                //salvo o token
                saveToken(response);
                ctx.dispatch('getUserFromToken')
                return true;
            },

            logmeasuser:async function(ctx, cpf ){
                    
                var resources = {};
                resources.cpf = cpf;
                var response = await api.postJSONAsync('logmeAsUser',resources)
                if(response.error){
                    return response;//await response.json();
                }
                //salvo o token
                saveToken(response);
                ctx.dispatch('getUserFromToken')
                return true;
        },

            logout: async(ctx)=>{
                // var response = await fetch(logout, {
                //             method:'POST',
                //             body: null,  //e sem credenciais para funcionar
                //             credentials: 'include',
                //             headers: {
                //                 'Accept': 'application/json',
                //                 'Content-Type': 'application/json',
                //                 'Authorization': 'Token '+token
                //             }
                // });
                // if(!response.ok){
                //     return response;
                // }
                var response = await api.postJSONAsync('logout')
                delete localStorage.token;
                ctx.commit('setMutation',{user:false})
            },



            getUserFromToken: async (ctx)=>{
                
                var token = getToken();
                // token = "0dde4893b0ec5b61955a5fd3362f7d8ae5147482";
                if(token){
                  //se tenho pego o usuario
                  var data = await getMeUser(token);
                  ctx.commit('setMutation',{ user:data });
                //   ctx.dispatch('loadUserInfo');
                    ctx.commit('setMutation',{loaded:true})
                  return data;
                }else{
                    ctx.commit('setMutation',{loaded:true})
                  return false;
                }
            }
            
        },

        //--GETTERS
        getters: {
            user:state=>{
                return state.user
            },
            loggedIn:state=>{
                return (state.user != false)
            },
            userInitialize:state=>{
                return state.loaded
            },
        },

    }
}



const getMeUser = async (token) => {
    var response = await api.getJSONAsync('currentUser')
    
    if (response.error) {
        return false;
    }
    return response;
}



const getToken = ()=>{
    let token = localStorage.token
    if(token)
        try{
            token = JSON.parse(token);
        }catch(e){
            return false
        }

    return token;
}

const saveToken = (token)=>{
    localStorage.token = JSON.stringify(token)
}

